/**
 * Dynamically load CookieYes script based on env flags, without requiring inline scripts.
 */
export function bootstrapCookiebar(): void {
  if (typeof document === "undefined") return;

  const flag = import.meta.env.VITE_COOKIEBAR_ENABLED;
  const enabled = flag === "true" || flag === "1" || flag === true;
  if (!enabled) return;

  const customUrl = String(import.meta.env.VITE_COOKIEBAR_SCRIPT_URL ?? "").trim();
  const siteId = String(import.meta.env.VITE_COOKIEBAR_SITE_ID ?? "").trim();
  const src = customUrl
    ? normalizeCookiebarScriptUrl(customUrl)
    : siteId
      ? `https://cdn-cookieyes.com/client_data/${encodeURIComponent(siteId)}/script.js`
      : "";
  if (!src) return;

  if (document.getElementById("cookieyes")) return;

  const s = document.createElement("script");
  s.id = "cookieyes";
  s.src = src;
  s.type = "text/javascript";
  document.head.appendChild(s);
}

function normalizeCookiebarScriptUrl(value: string): string {
  try {
    const url = new URL(value);
    if (url.protocol !== "https:" || url.username || url.password) return "";
    return url.href;
  } catch {
    return "";
  }
}
